"use client";

// import { useEffect, useState } from "react";
// import Card from "@/components/Card";
import SecondaryButton from "@/components/SecondaryButton/SecondaryButton";

export default function TrafficOverloadPage() {
  // const [timeLeft, setTimeLeft] = useState(300); // 5 minutes in seconds

  // useEffect(() => {
  //   const timer = setInterval(() => {
  //     setTimeLeft((prev) => {
  //       if (prev <= 1) {
  //         clearInterval(timer);
  //         return 0;
  //       }
  //       return prev - 1;
  //     });
  //   }, 1000);

  //   return () => clearInterval(timer);
  // }, []);

  // const formatTime = (seconds: number) => {
  //   const minutes = Math.floor(seconds / 60);
  //   const remainingSeconds = seconds % 60;
  //   return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  // };

  return (
    <div className="flex flex-col items-center gap-y-[72px] mt-[65px]">
      <div className="flex flex-col items-center gap-y-8 lg:max-w-[734px] w-[95%] text-center">
        <div className="font-gilroy-bold text-5xl uppercase text-white">
          High Traffic Alert
        </div>
        <div className="flex flex-col gap-y-6 items-center border border-[#333] bg-[#141416] lg:w-[512px] w-[95%] py-[60px] px-6">
          {/* Icon */}
          <div className="w-20 h-20 bg-[#2C2C30] rounded-full flex items-center justify-center mb-4">
            <svg
              className="w-10 h-10 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0"
              />
            </svg>
          </div>

          {/* Description */}
          <div className="flex flex-col gap-y-4 leading-6 text-[#9D9D9D] text-center">
            <p>
              Our servers are currently handling a massive influx of users
              trying to claim their <span className="text-white">SPON</span>{" "}
              rewards. To ensure everyone has a smooth experience, we've
              temporarily limited access.
            </p>

            {/* <div className="flex flex-col items-center gap-4 py-4">
              <div className="flex items-center gap-2 text-[#9D9D9D]">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                </svg>
                <span className="font-gilroy-medium">Please try again in:</span>
              </div>
              <div className="text-3xl font-gilroy-bold text-white">
                {formatTime(timeLeft)}
              </div>
            </div> */}

            <p className="text-sm">
              We're working to scale our infrastructure to handle the demand.
              Thank you for your patience!
            </p>
          </div>

          {/* Action Buttons */}
          <div className="grid grid-cols-1 gap-4 w-full mt-6">
            <SecondaryButton
              onClick={() => window.location.reload()}
              variant="light"
              className="w-full"
            >
              Visit Spheron
            </SecondaryButton>
            {/* <a 
              href="https://spheron.network" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <Card className="text-[#9D9D9D] hover:text-white hover:border-[#4C4C40] flex !items-center gap-2 px-4 !py-2">
                <span>Visit Spheron</span>
                <svg className="ml-auto w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </Card>
            </a> */}
          </div>

          {/* Status Indicator */}
          <div className="flex items-center gap-2 mt-6">
            <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
            <span className="text-sm text-[#9D9D9D] font-gilroy-medium">
              System Status: High Load
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
